module.exports = __webpack_public_path__ + "img/icon-linkedin.02228d8a.svg";